import { render, staticRenderFns } from "./CommandRelay.vue?vue&type=template&id=5706f9e0"
import script from "./CommandRelay.vue?vue&type=script&lang=js"
export * from "./CommandRelay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports